/**
 * YouTube URL parsing.
 *
 * Kept free of React and Chakra imports so it can be unit tested directly
 * without standing up a browser or a component tree.
 */

// Matches the id in any of the link shapes YouTube's own "Share" button can
// produce, so pasting any of them into Prismic works:
//   youtube.com/watch?v=ID   youtu.be/ID   youtube.com/embed/ID
//   youtube.com/shorts/ID    youtube.com/live/ID
const YOUTUBE_ID_PATTERNS = [
  /[?&]v=([A-Za-z0-9_-]{11})/,
  /youtu\.be\/([A-Za-z0-9_-]{11})/,
  /\/(?:embed|shorts|live|v)\/([A-Za-z0-9_-]{11})/
];

export const videoId = (url: string): string | undefined => {
  if (!url) {
    return undefined;
  }
  for (const pattern of YOUTUBE_ID_PATTERNS) {
    const match = pattern.exec(url);
    if (match) {
      return match[1];
    }
  }
  return undefined;
};
